module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","errorStreamingPrice":"Flex Passes are not permitted for MTI or Concord shows except if value is $0.","msg":{"success":"Your flexpass has been saved.","noEvents":"In order to be able to create a new flexpass, you need to publish at least one Event."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/locales/fr.json
// module id = 1733
// module chunks = 0